import { useEffect, useRef, useState } from "react";

const SEQUENCES = [
    [
        { text: "> INITIALISING TIMBOT...", cls: "text-slate-500" },
        { text: "> Checking available tools...", cls: "text-slate-500" },
        { text: "> Found Blender.", cls: "text-emerald-600" },
        { text: "> Found APIs.", cls: "text-emerald-600" },
        { text: "> Found Tim's latest idea.", cls: "text-cyan-700" },
        { text: "> Oh no.", cls: "text-amber-600" },
        { text: "> Proceeding anyway.", cls: "text-slate-900 font-bold" },
    ],
    [
        { text: "> TIMBOT TASK RECEIVED", cls: "text-slate-500" },
        { text: "> Complexity: unnecessary", cls: "text-slate-500" },
        { text: "> Practical value: unclear", cls: "text-slate-500" },
        { text: "> Tim enthusiasm: 97%", cls: "text-cyan-700" },
        { text: "> TASK APPROVED", cls: "text-emerald-600 font-bold" },
    ],
];

const CHAR_MS = 22;
const LINE_MS = 320;
const HOLD_MS = 4500;

export default function Terminal() {
    const [seqIdx, setSeqIdx] = useState(0);
    const [doneLines, setDoneLines] = useState([]);
    const [current, setCurrent] = useState("");
    const stateRef = useRef({ line: 0, char: 0 });

    useEffect(() => {
        const seq = SEQUENCES[seqIdx];
        const { line, char } = stateRef.current;
        let t;

        if (line >= seq.length) {
            t = setTimeout(() => {
                stateRef.current = { line: 0, char: 0 };
                setDoneLines([]);
                setCurrent("");
                setSeqIdx((i) => (i + 1) % SEQUENCES.length);
            }, HOLD_MS);
            return () => clearTimeout(t);
        }

        const full = seq[line].text;
        if (char < full.length) {
            t = setTimeout(() => {
                stateRef.current.char += 1;
                setCurrent(full.slice(0, stateRef.current.char));
            }, CHAR_MS);
        } else {
            t = setTimeout(() => {
                setDoneLines((d) => [...d, seq[line]]);
                setCurrent("");
                stateRef.current = { line: line + 1, char: 0 };
            }, LINE_MS);
        }
        return () => clearTimeout(t);
    }, [seqIdx, doneLines, current]);

    const currentCls = stateRef.current.line < SEQUENCES[seqIdx].length
        ? SEQUENCES[seqIdx][stateRef.current.line].cls
        : "text-slate-600";

    return (
        <div
            data-testid="timbot-terminal"
            className="rounded-lg border border-subtle bg-white p-6 font-mono text-xs shadow-2xl relative overflow-hidden"
        >
            <div className="flex items-center justify-between pb-4 border-b border-slate-200 mb-4 text-slate-500">
                <span className="flex items-center gap-2">
                    <span className="h-2 w-2 rounded-full bg-emerald-400 animate-led" />
                    <span className="text-cyan-600">TIMBOT_RUNTIME.sh</span>
                </span>
                <span>PID: 88492</span>
            </div>
            <div className="space-y-3 leading-relaxed min-h-[196px]">
                {doneLines.map((l, i) => (
                    <div key={i} className={l.cls}>
                        {l.text}
                    </div>
                ))}
                <div className={currentCls}>
                    {current}
                    <span className="inline-block w-2 h-3.5 bg-cyan-400 animate-caret align-middle ml-0.5" />
                </div>
            </div>
            <div className="mt-6 pt-4 border-t border-slate-200 flex items-center justify-between text-[11px] text-slate-500">
                <span>TASK COMPLEXITY: UNNECESSARY</span>
                <span className="text-cyan-600">APPROVAL: 97%</span>
            </div>
        </div>
    );
}
